<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="5">
					<!--제품 ID-->
					<search-input
						:label="getMessage_('SWCC000570')"
						paramKey="carVin"
						@commInput="setSearchParam"
						:propData="searchParams.carVin"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="5">
					<!--제품 ID-->
					<search-input
						:label="getMessage_('QWCC001538')"
						paramKey="pmcId"
						@commInput="setSearchParam"
						:propData="searchParams.pmcId"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import * as Yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchInput },
	computed: {
		...rootComputed,
		...serviceComputed,
		insVali() {
			return Yup.object().shape({
				// pmcId: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001538')])) //{0}은(는) 팔수 입력 값 입니다. ,  기술진단
			});
		}
	},
	methods: {
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		searchList() {
			const searchParams = this.searchParams;
			//벨리데이션 체크
			try {
				// this.insVali.validateSync(searchParams);
				if(this.searchParams.pmcId==='' && this.searchParams.carVin===''){
					throw new Error(this.getMessage_('QWCC002088'));
				}
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
				return error;
			}
			
			this.$sf_toggleLoading(true);
			this.getPmcTracking_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	async created() {
		try {
			//await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
